import type { CreateButtonProps } from './create-button.interface';
import type { FC } from 'react';

import cn from 'classnames';
import React from 'react';

import { IconCreate } from '../../icons/icon-create';

export const CreateButton: FC<CreateButtonProps> = ({
  noWrapper,
  type = 'button',
  isSmall,
  onClick,
  disabled,
  text,
}: CreateButtonProps) => {
  const wrapperClass = noWrapper ? '' : 'button__wrapper';
  const buttonClassList = cn(
    'button button_create',
    isSmall && 'button_create_small',
  );

  return (
    <div className={wrapperClass}>
      <button
        type={type}
        className={buttonClassList}
        onClick={onClick}
        disabled={disabled}
        data-controlled-permissions={CreateButton.name}
      >
        <IconCreate />
        {text}
      </button>
    </div>
  );
};
